module.exports = __webpack_public_path__ + "img/success.7f3e71f3.png";